import {memo, useRef, useState} from 'react';
import clsx from 'clsx';
import _isEqual from 'lodash/isEqual';
import {useTranslation} from 'react-i18next';
import AgyleButton from '../../../../../../../../../../components/ui/buttons/agyleButton';
import IconButton from '@mui/material/IconButton';
import {AgyleNamedIcon} from '../../../../../../../../../../components/icons/agyle';
import {useDailyCalendarTileStyles} from './dailyCalendarTileStyles';
import AgyleTextField from '../../../../../../../../../../components/ui/fields/agyleTextField';


const AvailableSlotTile = ({ event, locked, tileSelected, patientAssign, onClickAvailableSlot, onClickRemoveSlot }) => {
  const { t } = useTranslation();
  const classes = useDailyCalendarTileStyles();

  const rootRef = useRef();

  const [reason, setReason] = useState('');

  return (
    <div
      ref={rootRef}
      className={clsx(classes.availableSlot, classes.animation)}
    >
      <div style={{ display: 'flex', alignItems: 'center',alignContent: 'center', width: rootRef.current && rootRef.current.getBoundingClientRect().width, justifyContent: 'center', height: `100%`, flexWrap: 'wrap', gap: '12px' }}>
        {tileSelected && locked && <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexBasis: '100%', }}>
          <AgyleTextField value={reason} label="test" onChange={(e) => setReason(e.target.value)}></AgyleTextField>
        </div>}
          <AgyleButton
            variant={tileSelected ? 'contained' : 'text'}
            className={classes.availableSlotBtn}
            disabled={patientAssign && tileSelected}
            onClick={e => {
              e.stopPropagation();
              if (tileSelected || !patientAssign) return;

              const modifiedEv = {...event, reason};

              onClickAvailableSlot(modifiedEv);
            }}
          >
            {t(tileSelected ? 'Already selected' : 'Available slot')}
          </AgyleButton>

          {tileSelected && (
            <div className={classes.availableSlotEditSection}>
              <IconButton className={classes.availableSlotBinIcon} onClick={onClickRemoveSlot.bind(this, event)}>
                <AgyleNamedIcon name="bin"/>
              </IconButton>
            </div>
          )}
        </div>
    </div>
)
}

export default memo(AvailableSlotTile, _isEqual);